import '../vue_widget_wrapper.js.coffee'

Namespace 'Monitoring.Views.Charts'

class Monitoring.Views.Charts.ContentsSummary extends Monitoring.Views.Charts.VueWidgetWrapper

  url: '/monitoring/sessions/explorer/analyze_social_contents'

  initialize: (@options = {}) ->
    super($.extend(@options, {
      widget: 'text',
      title: I18n.t('monitoring.dashboard.charts.contents_summary.title')
    }))

  afterAppend: =>
    requestBody = { lang: I18n.locale, query: @searchQuery.toJSON() }
    @ajaxCall(@url, requestBody, (response) =>
      analyticsEvents.socialContentsAnalysis()

      @vueSortableBoundWidget.update({
        isLoading: false,
        data: { text: response.result.summary }
      })
    )
